module.exports = __webpack_public_path__ + "img/placemint.7f6820ca.png";